import { getCookieOrWebStorage, removeCookieOrWebStorage } from "./_cookies";

const getCaptchaSecurityCode = (type) => {
	if ($('#gcaptcha').length > 0) {
		$(".captchaContainer").show();
		if ($('script[src^="https://www.google.com/recaptcha/api.js"]').length <= 1) {
			window.gcaptchaCallback = function () {
				if ($('.gift-card-balance-page').length > 0 && getCookieOrWebStorage('grecaptchaReload')) {
					removeCookieOrWebStorage('grecaptchaReload');
					grecaptcha.reset();
				} else {
					grecaptcha.render('gcaptcha', {
						'sitekey': '6LfD2CgUAAAAAIg0Q5zDLCl9vSx9jyXXPlu86L1N',
						'theme': 'light',
						'size': $('.desktopPage #emailProduct, .tabletPage #emailProduct').length > 0 ? 'compact' : 'normal'
					});
					if ($('#paymentPage').length > 0) setCookieOrWebStorage('sessionStorage', 'grecaptchaReload', true);
				}
				$('#g-recaptcha-response').data('validate', 'required').attr('data-validate', 'required');
				$('#g-recaptcha-response').attr('data-original-title', 'You must check the box to continue.');
				$('#g-recaptcha-response').data('fieldValid', false);
			}
			var loadCaptcha = function () {$('head').append('<script src="https://www.google.com/recaptcha/api.js?onload=gcaptchaCallback&render=explicit" async defer></script>') };
			if ($('script[src^="https://www.google.com/recaptcha/api.js"]').length != 0) {
				$('script[src^="https://www.google.com/recaptcha/api.js"]').remove();
				$('#gcaptcha').empty(); // google captcha throws an error unless its container is emptied out along with  the script call
			}
			loadCaptcha();
		};
	} 
	return false;
};
export {
	getCaptchaSecurityCode
};
